const React = require('react');
const { createElement: h, useState, useEffect } = React;
const templateStore = require('../lib/templateStore');
const { setAccessToken } = require('../lib/apiClient');
require('./AdminDashboardPage.css');

var EMPTY_FORM = {
  id: '', title: '', summary: '', category: '', subcategory: '',
  connectors: '', coverImage: '', readme: '', sourceWorkflowId: '',
  published: false, featured: false, order: 0
};

// ── Login gate ───────────────────────────────────────────────────────────────

function AdminLogin(props) {
  var [username, setUsername] = useState('');
  var [password, setPassword] = useState('');
  var [error, setError] = useState('');
  var [busy, setBusy] = useState(false);

  function submit(e) {
    e.preventDefault();
    setBusy(true);
    setError('');
    templateStore.adminLogin(username.trim(), password.trim())
      .then(function() { props.onAuthed(); })
      .catch(function(err) { setBusy(false); setError(err.message || 'Login failed.'); });
  }

  return h('div', { className: 'adm-login' },
    h('form', { className: 'adm-login-card', onSubmit: submit, autoComplete: 'off' },
      h('div', { className: 'adm-login-title' }, 'Super Admin'),
      h('div', { className: 'adm-login-sub' }, 'Sign in to manage the Template Store.'),
      h('input', { className: 'adm-input', type: 'text', name: 'adm-user', placeholder: 'Username', value: username, onChange: function(e) { setUsername(e.target.value); }, autoComplete: 'off', autoFocus: true }),
      h('input', { className: 'adm-input', type: 'password', name: 'adm-pass', placeholder: 'Password', value: password, onChange: function(e) { setPassword(e.target.value); }, autoComplete: 'new-password' }),
      error ? h('div', { className: 'adm-error' }, error) : null,
      h('button', { className: 'adm-btn adm-btn--primary', type: 'submit', disabled: busy }, busy ? 'Signing in…' : 'Sign in')
    )
  );
}

// ── Template form (create / edit) ────────────────────────────────────────────

function field(label, input) {
  return h('label', { className: 'adm-field' }, h('span', { className: 'adm-field-label' }, label), input);
}

function TemplateForm(props) {
  var f = props.form;
  var isEdit = !!f.id;
  function update(key, val) {
    var next = Object.assign({}, f);
    next[key] = val;
    props.onChange(next);
  }

  return h('div', { className: 'adm-form' },
    h('div', { className: 'adm-form-head' }, isEdit ? 'Edit template' : 'Publish a new template'),
    field('Source workflow ' + (isEdit ? '(pick to replace the saved snapshot)' : '(required)'),
      h('select', { className: 'adm-input', value: f.sourceWorkflowId, onChange: function(e) { update('sourceWorkflowId', e.target.value); } },
        [h('option', { key: '', value: '' }, isEdit ? '— keep current snapshot —' : '— select a workflow —')].concat(
          (props.sources || []).map(function(w) {
            return h('option', { key: w.id, value: w.id }, w.name + ' (' + w.id.slice(0, 10) + '…)');
          })
        )
      )
    ),
    field('Title', h('input', { className: 'adm-input', value: f.title, onChange: function(e) { update('title', e.target.value); } })),
    field('Summary (card subtitle)', h('input', { className: 'adm-input', value: f.summary, onChange: function(e) { update('summary', e.target.value); } })),
    h('div', { className: 'adm-row' },
      field('Category', h('input', { className: 'adm-input', value: f.category, onChange: function(e) { update('category', e.target.value); } })),
      field('Subcategory', h('input', { className: 'adm-input', value: f.subcategory, onChange: function(e) { update('subcategory', e.target.value); } }))
    ),
    field('Connectors (comma separated)', h('input', { className: 'adm-input', placeholder: 'Gmail, Jira, Tavily', value: f.connectors, onChange: function(e) { update('connectors', e.target.value); } })),
    field('Cover image URL (optional)', h('input', { className: 'adm-input', placeholder: 'https://…', value: f.coverImage, onChange: function(e) { update('coverImage', e.target.value); } })),
    field('README — how to run this workflow (markdown)',
      h('textarea', { className: 'adm-input adm-textarea', rows: 10, placeholder: 'Setup steps, variables to set, sheets to create, accounts to connect…', value: f.readme, onChange: function(e) { update('readme', e.target.value); } })
    ),
    h('div', { className: 'adm-row' },
      field('Sort order', h('input', { className: 'adm-input', type: 'number', value: f.order, onChange: function(e) { update('order', e.target.value); } })),
      h('label', { className: 'adm-check' },
        h('input', { type: 'checkbox', checked: !!f.published, onChange: function(e) { update('published', e.target.checked); } }),
        h('span', null, 'Published (visible in the store)')
      ),
      h('label', { className: 'adm-check' },
        h('input', { type: 'checkbox', checked: !!f.featured, onChange: function(e) { update('featured', e.target.checked); } }),
        h('span', null, 'Featured (fills the store banner — only one)')
      )
    ),
    props.error ? h('div', { className: 'adm-error' }, props.error) : null,
    h('div', { className: 'adm-form-actions' },
      h('button', { className: 'adm-btn adm-btn--primary', type: 'button', disabled: props.saving, onClick: props.onSave }, props.saving ? 'Saving…' : (isEdit ? 'Save changes' : 'Publish template')),
      isEdit ? h('button', { className: 'adm-btn', type: 'button', onClick: props.onCancel }, 'New template') : null
    )
  );
}

// ── Template list ────────────────────────────────────────────────────────────

var STATUS_LABEL = { pending: 'Pending review', approved: 'Approved', rejected: 'Rejected' };
var VERSION_LABEL = { pending: 'pending', approved: 'approved', rejected: 'rejected', superseded: 'replaced' };

function fmtDate(d) {
  if (!d) return '';
  try { return new Date(d).toLocaleDateString(); } catch (e) { return ''; }
}

// View-only timeline of every version submitted for this listing (newest first).
function VersionHistory(props) {
  var versions = (props.versions || []).slice().reverse();
  if (versions.length <= 1) return null;
  return h('div', { className: 'adm-vh' },
    h('div', { className: 'adm-vh-head' }, 'Version history'),
    versions.map(function(v, i) {
      var st = v.status || 'pending';
      return h('div', { className: 'adm-vh-row', key: i },
        h('span', { className: 'adm-vh-ver' }, 'v' + (v.version || '?')),
        h('span', { className: 'adm-vh-status adm-vh-status--' + st }, VERSION_LABEL[st] || st),
        v.createdAt ? h('span', { className: 'adm-vh-date' }, fmtDate(v.createdAt)) : null,
        v.changelog ? h('span', { className: 'adm-vh-note' }, v.changelog) : null
      );
    })
  );
}

function TemplateRow(props) {
  var t = props.template;
  var status = t.status || 'pending';
  return h('div', { className: 'adm-li' + (status === 'pending' ? ' adm-li--pending' : '') },
    h('div', { className: 'adm-li-main' },
      h('div', { className: 'adm-li-title' }, t.title,
        t.version ? h('span', { className: 'adm-pill adm-pill--ver' }, 'v' + t.version + (t.published ? ' live' : '')) : null,
        t.pendingVersion ? h('span', { className: 'adm-pill adm-pill--ver-pending' }, 'v' + t.pendingVersion + ' pending') : null,
        h('span', { className: 'adm-pill adm-pill--' + status }, STATUS_LABEL[status] || status),
        t.published ? h('span', { className: 'adm-pill adm-pill--live' }, 'Live') : null,
        t.featured ? h('span', { className: 'adm-pill adm-pill--live' }, '★ Featured') : null
      ),
      h('div', { className: 'adm-li-meta' }, [t.category, t.subcategory].filter(Boolean).join(' · ') + ' · ' + (t.nodeCount || 0) + ' nodes · ' + (t.installCount || 0) + ' installs'),
      h(VersionHistory, { versions: t.versions })
    ),
    props.confirming
      ? h('div', { className: 'adm-li-actions' },
          h('span', { className: 'adm-confirm-q' }, 'Delete?'),
          h('button', { className: 'adm-btn adm-btn--sm adm-btn--danger', type: 'button', onClick: function() { props.onConfirmDelete(t); } }, 'Yes, delete'),
          h('button', { className: 'adm-btn adm-btn--sm', type: 'button', onClick: function() { props.onCancelDelete(); } }, 'Cancel')
        )
      : h('div', { className: 'adm-li-actions' },
          status !== 'approved'
            ? h('button', { className: 'adm-btn adm-btn--sm adm-btn--approve', type: 'button', onClick: function() { props.onReview(t, 'approve'); } }, 'Approve')
            : null,
          status !== 'rejected'
            ? h('button', { className: 'adm-btn adm-btn--sm', type: 'button', onClick: function() { props.onReview(t, 'reject'); } }, status === 'approved' ? 'Unpublish' : 'Reject')
            : null,
          h('button', { className: 'adm-btn adm-btn--sm', type: 'button', onClick: function() { props.onEdit(t); } }, 'Edit'),
          h('button', { className: 'adm-btn adm-btn--sm adm-btn--danger', type: 'button', onClick: function() { props.onAskDelete(t.id); } }, 'Delete')
        )
  );
}

// ── Waitlist section ──────────────────────────────────────────────────────────

function WaitlistSection(props) {
  var [entries, setEntries] = useState([]);
  var [loading, setLoading] = useState(true);
  var [error, setError] = useState('');

  function reload() {
    setLoading(true);
    return templateStore.adminListWaitlist()
      .then(function(list) { setEntries(list || []); setLoading(false); })
      .catch(function(e) {
        setLoading(false);
        if (e && e.status === 401) { templateStore.adminLogout(); props.onSignedOut(); return; }
        setError(e.message || 'Failed to load waitlist.');
      });
  }

  useEffect(function() { reload(); }, []);

  function review(entry, action) {
    setError('');
    var op = action === 'approve'
      ? templateStore.adminApproveWaitlist(entry._id)
      : templateStore.adminRejectWaitlist(entry._id);
    op.then(reload).catch(function(e) { setError(e.message || 'Action failed.'); });
  }

  // Pending entries float to the top so they're reviewed first.
  var ordered = entries.slice().sort(function(a, b) {
    var ap = (a.status === 'pending') ? 0 : 1;
    var bp = (b.status === 'pending') ? 0 : 1;
    return ap - bp;
  });
  var pendingCount = entries.filter(function(e) { return e.status === 'pending'; }).length;

  return h('div', { className: 'adm-col-list', style: { marginBottom: 32 } },
    h('div', { className: 'adm-list-head' },
      'Beta waitlist',
      pendingCount ? h('span', { className: 'adm-pending-count' }, pendingCount + ' pending') : null
    ),
    error ? h('div', { className: 'adm-error' }, error) : null,
    loading ? h('div', { className: 'adm-muted' }, 'Loading…') : null,
    !loading && !entries.length ? h('div', { className: 'adm-muted' }, 'No waitlist entries yet.') : null,
    ordered.map(function(e) {
      var status = e.status || 'pending';
      return h('div', { className: 'adm-li' + (status === 'pending' ? ' adm-li--pending' : ''), key: e._id },
        h('div', { className: 'adm-li-main' },
          h('div', { className: 'adm-li-title' }, e.email,
            h('span', { className: 'adm-pill adm-pill--' + status }, STATUS_LABEL[status] || status)
          ),
          h('div', { className: 'adm-li-meta' },
            [e.name, e.company, e.job].filter(Boolean).join(' · ') || '—'),
          e.reason ? h('div', { className: 'adm-li-meta' }, e.reason) : null
        ),
        h('div', { className: 'adm-li-actions' },
          status !== 'approved'
            ? h('button', { className: 'adm-btn adm-btn--sm adm-btn--approve', type: 'button', onClick: function() { review(e, 'approve'); } }, 'Approve')
            : h('button', { className: 'adm-btn adm-btn--sm', type: 'button', onClick: function() { review(e, 'reject'); } }, 'Revoke')
        )
      );
    })
  );
}

// ── Users section ─────────────────────────────────────────────────────────────

// Browse every registered user and "Login as" any of them: the server mints a
// regular session token, we install it as the normal user session and reload
// into the dashboard — the admin now sees the app exactly as that user does.
function UsersSection(props) {
  var [users, setUsers] = useState([]);
  var [query, setQuery] = useState('');
  var [loading, setLoading] = useState(true);
  var [error, setError] = useState('');
  var [busyId, setBusyId] = useState('');

  useEffect(function() {
    templateStore.adminListUsers()
      .then(function(list) { setUsers(list || []); setLoading(false); })
      .catch(function(e) {
        setLoading(false);
        if (e && e.status === 401) { templateStore.adminLogout(); props.onSignedOut(); return; }
        setError(e.message || 'Failed to load users.');
      });
  }, []);

  function loginAs(u) {
    setBusyId(u.id);
    setError('');
    templateStore.adminLoginAsUser(u.id)
      .then(function(r) {
        if (!r || !r.token) throw new Error('No session token returned.');
        setAccessToken(r.token);
        window.location.assign('/dashboard');
      })
      .catch(function(e) { setBusyId(''); setError(e.message || 'Login as failed.'); });
  }

  var q = query.trim().toLowerCase();
  var filtered = q
    ? users.filter(function(u) {
        return (u.username || '').toLowerCase().indexOf(q) !== -1 ||
               (u.email || '').toLowerCase().indexOf(q) !== -1;
      })
    : users;

  return h('div', { className: 'adm-col-list', style: { marginBottom: 32 } },
    h('div', { className: 'adm-list-head' }, 'Users',
      h('span', { className: 'adm-pending-count' }, users.length + ' total')
    ),
    h('input', {
      className: 'adm-input', type: 'text', placeholder: 'Search by username or email…',
      value: query, onChange: function(e) { setQuery(e.target.value); },
      style: { marginBottom: 12 }
    }),
    error ? h('div', { className: 'adm-error' }, error) : null,
    loading ? h('div', { className: 'adm-muted' }, 'Loading…') : null,
    !loading && !filtered.length ? h('div', { className: 'adm-muted' }, q ? 'No users match.' : 'No users yet.') : null,
    filtered.map(function(u) {
      return h('div', { className: 'adm-li', key: u.id },
        h('div', { className: 'adm-li-main' },
          h('div', { className: 'adm-li-title' }, u.username,
            h('span', { className: 'adm-pill' }, u.plan)
          ),
          h('div', { className: 'adm-li-meta' },
            [u.email, u.createdAt ? ('joined ' + fmtDate(u.createdAt)) : ''].filter(Boolean).join(' · ') || '—')
        ),
        h('div', { className: 'adm-li-actions' },
          h('button', {
            className: 'adm-btn adm-btn--sm adm-btn--approve', type: 'button',
            disabled: !!busyId, onClick: function() { loginAs(u); }
          }, busyId === u.id ? 'Signing in…' : 'Login as')
        )
      );
    })
  );
}

// ── Manager ──────────────────────────────────────────────────────────────────

function AdminManager(props) {
  var [templates, setTemplates] = useState([]);
  var [sources, setSources] = useState([]);
  var [form, setForm] = useState(EMPTY_FORM);
  var [loading, setLoading] = useState(true);
  var [saving, setSaving] = useState(false);
  var [error, setError] = useState('');
  var [confirmDeleteId, setConfirmDeleteId] = useState('');

  function reload() {
    setLoading(true);
    return Promise.all([templateStore.adminListTemplates(), templateStore.adminListSourceWorkflows()])
      .then(function(res) { setTemplates(res[0] || []); setSources(res[1] || []); setLoading(false); })
      .catch(function(e) {
        setLoading(false);
        if (e && e.status === 401) { templateStore.adminLogout(); props.onSignedOut(); return; }
        setError(e.message || 'Failed to load.');
      });
  }

  useEffect(function() { reload(); }, []);

  function buildPayload() {
    return {
      title: form.title, summary: form.summary, category: form.category, subcategory: form.subcategory,
      connectors: form.connectors, coverImage: form.coverImage, readme: form.readme,
      published: form.published, featured: form.featured, order: Number(form.order) || 0,
      sourceWorkflowId: form.sourceWorkflowId || undefined
    };
  }

  function save() {
    if (!form.title.trim()) { setError('Title is required.'); return; }
    if (!form.id && !form.sourceWorkflowId) { setError('Pick a source workflow to publish.'); return; }
    setSaving(true);
    setError('');
    var op = form.id
      ? templateStore.adminUpdateTemplate(form.id, buildPayload())
      : templateStore.adminCreateTemplate(buildPayload());
    op.then(function() { setSaving(false); setForm(EMPTY_FORM); return reload(); })
      .catch(function(e) { setSaving(false); setError(e.message || 'Save failed.'); });
  }

  function edit(t) {
    setForm({
      id: t.id, title: t.title || '', summary: t.summary || '', category: t.category || '',
      subcategory: t.subcategory || '', connectors: (t.connectors || []).join(', '),
      coverImage: t.coverImage || '', readme: t.readme || '', sourceWorkflowId: '',
      published: !!t.published, featured: !!t.featured, order: t.order || 0
    });
    setError('');
    if (typeof window !== 'undefined') window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function remove(t) {
    setConfirmDeleteId('');
    templateStore.adminDeleteTemplate(t.id).then(reload).catch(function(e) { setError(e.message || 'Delete failed.'); });
  }

  function review(t, action) {
    setError('');
    templateStore.adminReviewTemplate(t.id, action).then(reload).catch(function(e) { setError(e.message || 'Review failed.'); });
  }

  // Pending submissions float to the top so they're reviewed first.
  var ordered = templates.slice().sort(function(a, b) {
    var ap = (a.status === 'pending') ? 0 : 1;
    var bp = (b.status === 'pending') ? 0 : 1;
    return ap - bp;
  });
  var pendingCount = templates.filter(function(t) { return t.status === 'pending'; }).length;

  return h('div', { className: 'adm-manager' },
    h('div', { className: 'adm-bar' },
      h('div', { className: 'adm-bar-title' }, 'Admin'),
      h('button', { className: 'adm-btn adm-btn--sm', type: 'button', onClick: function() { templateStore.adminLogout(); props.onSignedOut(); } }, 'Sign out')
    ),
    h(WaitlistSection, { onSignedOut: props.onSignedOut }),
    h(UsersSection, { onSignedOut: props.onSignedOut }),
    h('div', { className: 'adm-cols' },
      h('div', { className: 'adm-col-form' },
        h(TemplateForm, { form: form, sources: sources, saving: saving, error: error, onChange: setForm, onSave: save, onCancel: function() { setForm(EMPTY_FORM); setError(''); } })
      ),
      h('div', { className: 'adm-col-list' },
        h('div', { className: 'adm-list-head' },
          'Templates',
          pendingCount ? h('span', { className: 'adm-pending-count' }, pendingCount + ' pending review') : null
        ),
        loading ? h('div', { className: 'adm-muted' }, 'Loading…') : null,
        !loading && !templates.length ? h('div', { className: 'adm-muted' }, 'No templates yet.') : null,
        ordered.map(function(t) {
          return h(TemplateRow, {
            key: t.id,
            template: t,
            confirming: confirmDeleteId === t.id,
            onReview: review,
            onEdit: edit,
            onAskDelete: function(id) { setConfirmDeleteId(id); },
            onCancelDelete: function() { setConfirmDeleteId(''); },
            onConfirmDelete: remove
          });
        })
      )
    )
  );
}

function AdminDashboardPage(props) {
  var [authed, setAuthed] = useState(templateStore.isAdminAuthed());
  return h('div', { className: 'adm-page' },
    h('div', { className: 'adm-top' },
      h('button', { className: 'adm-home', type: 'button', onClick: function() { props.onNavigateTo(props.currentUser ? '/dashboard' : '/'); } }, '← Exit admin')
    ),
    authed
      ? h(AdminManager, { onSignedOut: function() { setAuthed(false); } })
      : h(AdminLogin, { onAuthed: function() { setAuthed(true); } })
  );
}

module.exports = AdminDashboardPage;
